import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserProfile } from 'src/app/models/model';
import { AssignedRole } from 'src/app/models/data/assignedRole';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AppDialogComponent } from 'src/app/components/app-dialog/app-dialog.component';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { lastValueFrom } from 'rxjs';
import { LoginContainerComponent } from '../login-container/login-container.component';
import { MatIcon } from '@angular/material/icon';
import { LoadingIndicatorComponent } from '../../../components/loading-indicator/loading-indicator.component';
import { MatActionList } from '@angular/material/list';
import { LoginSelectRoleItemComponent } from './login-select-role-item/login-select-role-item.component';

@Component({
	selector: 'app-active-role',
	templateUrl: 'login-select-role.component.html',
	styleUrls: ['../login.component.scss', '../../common/main.scss'],
	imports: [
		LoginContainerComponent,
		MatIcon,
		LoadingIndicatorComponent,
		MatActionList,
		LoginSelectRoleItemComponent,
	],
})
export class LoginSelectRoleComponent implements OnInit {
	userProfile?: UserProfile = undefined;

	constructor(
		private authService: AuthService,
		private router: Router,
		private dialog: MatDialog,
		private profileService: UserProfileService,
		private readonly loadingService: LoadingIndicatorService
	) {}

	async ngOnInit(): Promise<void> {
		this.userProfile = await this.profileService.getUserProfile();

		if (this.userProfile.availableAssignedRoles.length === 0) {
			const dialog = this.dialog.open(AppDialogComponent, {
				data: {
					title: 'User has no active roles',
					message: `Please assign a role to ${this.userProfile?.user.email} before trying to sign in again`,
				},
			});
			lastValueFrom(dialog.afterClosed()).then(() =>
				this.router.navigateByUrl('/login')
			);
		}
	}

	onRoleSelected(role: AssignedRole): void {
		this.authService
			.updateCustomClaims(role.entityRelationshipId)
			.then((_) => this.router.navigateByUrl('/'))
			.catch(async (_) => {
				await this.authService.logout();
				await this.router.navigateByUrl('/login');
			});
	}
}
